module.exports = __webpack_public_path__ + "static/media/main_slider_1.b82878f6.jpg";